import { __AppElementType } from "../common/Dictionaries";
import { 
	SET_TEMPLATETYPE_LIST,
	SET_ELEMENT_LIST,
	SET_APPELEMENT_LIST,
	SET_TEMPLATE_STRUCTURE,
	SET_COMPONENT_STRUCTURE,
	SET_TEMPLATE_CONFIG_PROPERTY,
} from "./actions/KPI/actions";

const initialState = {
	_templateStructure: null,
	_componentStructure: null,

	_templateTypeList: null,
	_appElementTypeList: null,
	_elementList: null,
	
	_templateConfig: {	
		title: "",
		templateTypeSelected: null,
		appElementSelected: null,
		elementSelected: null
	}
};
const boardConfigReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_TEMPLATETYPE_LIST:
			return {
				...state,
				_templateTypeList: action.payload
			};
		case SET_ELEMENT_LIST:
			return {
				...state,
				_elementList: action.payload
			};
		case SET_APPELEMENT_LIST:
			return {
				...state,
				_appElementTypeList: action.payload
			};
		case SET_TEMPLATE_STRUCTURE:
			return {
				...state,
				_templateStructure: action.payload
			};
		case SET_COMPONENT_STRUCTURE:
			return {
				...state,
				_componentStructure: action.payload
			};

		case SET_TEMPLATE_CONFIG_PROPERTY:
			return {
				...state,
				_templateConfig: {
				  	...state._templateConfig,
				  	[action.payload.fieldName]: action.payload.value
				}
			};

		default:
			return state;
	}
};

export default boardConfigReducer;